module.exports = __webpack_public_path__ + "img/69.da2dcf92.svg";